import {
  WHOS_ON_CALL_DIALOG_OPEN,
  WHOS_ON_CALL_DIALOG_CLOSE,
} from 'actions/group';

export const defaultState = {
  isDialogOpen: false,
  group: null,
  history: [],
  start: null,
  end: null,
};

export default function groupOnCallList(state = defaultState, action) {
  switch (action.type) {
    case WHOS_ON_CALL_DIALOG_OPEN: {
      const { group, history, start, end } = action.payload;
      const newHistory = [...(history || state.history)];
      if (state.isDialogOpen && !history) {
        newHistory.push(state.group);
      }
      return {
        ...state,
        group,
        start,
        end,
        history: newHistory,
        isDialogOpen: true,
      };
    }
    case WHOS_ON_CALL_DIALOG_CLOSE: {
      return {
        ...state,
        history: [],
        isDialogOpen: false,
        start: null,
        end: null,
        group: null,
      };
    }
    default:
      return state;
  }
}
